import React from 'react';
import { useFormContext, get } from 'react-hook-form';
import PropTypes from 'prop-types';

const FieldErrorMessage = (props) => {
  const { errors, formState } = useFormContext();
  const { name } = props;

  const fieldError = get(errors, name);
  const fieldTouched = get(formState.touched, name);

  const shouldShowError = name === 'mobile_phone' ? fieldError : fieldError && fieldTouched;

  return (
    <>
      {shouldShowError && (
        <div className={'form-item--error'}>{fieldError.message}</div>
      )}
    </>
  );
};

FieldErrorMessage.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FieldErrorMessage;